/**
 * Session-scoped de-dupe for exclusive→shared fallback notices.
 * Device key: shown at most once per DAC per session.
 */

const shownDeviceKeys = new Set<string>();

/** @deprecated Prefer exclusiveFallbackDeviceNoticeKey — kept for callers keyed by format. */
const shownFormatKeys = new Set<string>();

export function exclusiveFallbackDeviceNoticeKey(deviceId: string): string {
  return String(deviceId || '').trim();
}

/** Returns true the first time this device triggers a fallback notice this session. */
export function shouldShowExclusiveFallbackDeviceNotice(key: string): boolean {
  if (!key || shownDeviceKeys.has(key)) return false;
  shownDeviceKeys.add(key);
  return true;
}

/** @deprecated Use exclusiveFallbackDeviceNoticeKey + shouldShowExclusiveFallbackDeviceNotice. */
export function exclusiveFallbackNoticeKey(
  deviceId: string,
  sampleRate: number,
  bitDepth: number,
): string {
  return `${deviceId}|${sampleRate}|${bitDepth}`;
}

/** @deprecated Use shouldShowExclusiveFallbackDeviceNotice. */
export function shouldShowExclusiveFallbackNotice(key: string): boolean {
  if (shownFormatKeys.has(key)) return false;
  shownFormatKeys.add(key);
  return true;
}
